import { render, staticRenderFns } from "./restricciones.vue?vue&type=template&id=24def39c&scoped=true"
import script from "./restricciones.vue?vue&type=script&lang=js"
export * from "./restricciones.vue?vue&type=script&lang=js"
import style0 from "./restricciones.vue?vue&type=style&index=0&id=24def39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24def39c",
  null
  
)

export default component.exports